import script from "./RoomDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDetails.vue?vue&type=script&setup=true&lang=js"

import "./RoomDetails.vue?vue&type=style&index=0&id=0be5cea7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be5cea7"]])

export default __exports__